import React, { useEffect, useState } from 'react';
import { useGetTvQuery } from '../../services/movieApi';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { Link } from 'react-router-dom';

const Tv = () => {
  const getPosterCard = (posterpath) => {
    return `https://image.tmdb.org/t/p/w500/${posterpath}`;
  };

  const [page, setPage] = useState(1);
  const { data: dataTv, isFetching } = useGetTvQuery({ page });

  const [items, setItems] = useState([]);
  const totalPages = dataTv?.total_pages;

  useEffect(() => {
    const fetchData = async () => {
      const data2 = await dataTv?.results;
      setItems(data2);
    };
    fetchData();
  }, [dataTv]);

  const handleLoadMore = () => {
    setPage(page + 1);
    setItems([...dataTv?.results]);
  };
  const handlePrevMore = () => {
    setPage(page - 1);
    setItems([...dataTv?.results]);
  };

  if (isFetching) return 'Loading...';

  return (
    <div className="bg-black text-white">
      <Navbar />
      <Footer headerMovies title="TV" />
      <div className="flex flex-wrap justify-center gap-4">
        {items?.map((r) => (
          <Link
            to={`/tv/${r.id}`}
            key={r.id}
            className="flex flex-col w-40 lg:w-52"
          >
            <img
              src={getPosterCard(r.poster_path)}
              className="bg-cover relative rounded-2xl scale-95 hover:scale-100 duration-300"
            />
            {r.original_title}
          </Link>
        ))}
      </div>
      {page < totalPages ? (
        <>
          {page > 1 ? (
            <div className="flex flex-row justify-center gap-4 items-center py-6">
              <button
                onClick={handlePrevMore}
                className="border-none px-4 py-1 rounded-xl bg-white/70"
              >
                PrevMore
              </button>
              {page}
              <button
                onClick={handleLoadMore}
                className="border-none px-4 py-1 rounded-2xl bg-red-500"
              >
                LoadMore
              </button>
            </div>
          ) : (
            <div className="text-center py-6">
              <button
                onClick={handleLoadMore}
                className="border-none px-4 py-1 rounded-2xl bg-red-500"
              >
                LoadMore
              </button>
            </div>
          )}
        </>
      ) : null}
      <Footer />
    </div>
  );
};

export default Tv;
